import RequestTimeout from '@package/components/ErrorPages/RequestTimeout/RequestTimeout';

export default RequestTimeout;
